import { HomeActions, HomeActionTypes } from './home.actions';
import { HomeStateInterface, RequestTypeEnum, UpdateCurrentActivityResponseModel } from './home.model';
import {
  IHomeMetricSet,
  IHomeMetricSetItem,
  ILayout,
  ILayoutTaskGroupItem,
} from '../settings/home-page-display-settings/home-page-display-settings.model';
import { PhaseDurationTypeEnum } from '../../view/home/home-metrics/common-phase-duration-metric/common-phase-duration-metric.model';
import _ from 'lodash';
import { HelperService } from '../../shared/service/helper.service';
import { EPages } from '../../view/settings/home-page-display-settings/home-page-display-settings.constants';
import { StatusesEnum } from '../../../constants';

export const initialState: HomeStateInterface = {
  line: undefined,
  user: undefined,
  errors: [],
  generatedActivityButtons: [],
  homeInformationLoading: false,
  homeInformationLoaded: false,
  activityTreeGraphData: [],
  cicoAccess: false,
  cicoPending: false,
  saveWorkOrderFeedbackLoading: false,
  saveWorkOrderFeedbackLoaded: false,
  getWorkOrderFeedbackLoading: false,
  getWorkOrderFeedbackLoaded: false,
  updateWorkOrderFeedbackLoading: false,
  updateWorkOrderFeedbackLoaded: false,
  workOrderCloseFeedback: {
    id: null,
    workOrderId: null,
    crewPerformPoint: null,
    goodThings: '',
    needToBeImprove: '',
  },
  activityTreeGraphDataLoading: false,
  activityTreeGraphDataLoaded: false,
  changeActivityLoading: false,
  changeActivityCompleted: false,
  updateCurrentActivityLoading: false,
  checkWorkOrderLoading: false,
  updateWorkOrderLoading: false,
  getWorkOrderLoading: false,
  workOrderStatusLoading: false,
  getVersionDetailLoading: false,
  getProductPerformanceLoading: false,
  productSearchLoading: false,
  getWorkOrderNumbersLoading: false,
  searchUsersByFilterLoading: false,
  searchAssetsByFilterLoading: false,
  homeMetricSetItemsLoading: false,
  homeMetricSetItemsParams: null,
  homeMetricSetItemsLoaded: false,
  homeMetricSetItems: [],
  phaseDurationLoading: false,
  phaseDurationLoaded: false,
  phaseDurations: null,
  phaseComments: {
    preRun: null,
    postRun: null,
    run: null,
  },
  phaseCommentsLoading: false,
  phaseCommentsLoaded: false,
  phaseCommentSubmitLoading: false,
  phaseCommentSubmitLoaded: false,
  isDigitalFormsActive: false,
  isAutomatedPhaseCommentsActive: false,
  phaseCommentsEnteredStatus: null,
  previousPhase: null,
  getLineInfoThatSelectedWorkOrderLoading: false,
  getLineInfoThatSelectedWorkOrderLoaded: false,
  getLineInfoThatSelectedWorkOrderData: null,
  splitWorkOrderOnLinePredictedWorkOrderNumberLoading: false,
  splitWorkOrderOnLinePredictedWorkOrderNumberLoaded: false,
  splitWorkOrderOnLinePredictedWorkOrderNumberData: null,
  requestType: RequestTypeEnum.DEFAULT,
  activityHistoryDataLoading: false,
  activityHistoryDataLoaded: false,
  activityHistoryData: null,
  getProductTransitionMatrixLoading: false,
  getProductTransitionMatrixLoaded: false,
  productTransitionMatrix: null,
  getPreviousWorkOrderLoading: false,
  getPreviousWorkOrderLoaded: false,
  previousWorkOrder: [],
  homeMetricLoadingComplete: false,
  isLinePathUtilized: null,
  isWorkOrderMissing: false,
  workOrderMissingControlLoading: false,
  workOrderMissingControlLoaded: false,
  isZeroCuntReceived: false,
  microStopSensorType: null,
  auditLogUuid: null,
  getSelectedLineWorkOrderSplitStatusLoading: false,
  getSelectedLineWorkOrderSplitStatusLoaded: false,
  selectedLineIsWorkOrderSplitActive: false,
  getTargetSpeedPlaceholderLoading: false,
  getTargetSpeedPlaceholderLoaded: false,
  expectedTargetSpeed: null,
  isDefaultFavTask: false,
  layoutTaskGroupItem: [],
  removeWorkOrderOnLineLoading: false,
  removeWorkOrderOnLineLoaded: false
};

export function homeReducer(state = initialState, action: HomeActions): HomeStateInterface {
  switch (action.type) {
    case HomeActionTypes.ChangeActivity:
      return {
        ...state,
        changeActivityLoading: true,
        changeActivityCompleted: false,
      };
    case HomeActionTypes.SetChangeActivityLoading:
      return {
        ...state,
        changeActivityLoading: action.loadingState,
      };
    case HomeActionTypes.ChangeActivityError:
      return {
        ...state,
        changeActivityLoading: false,
        changeActivityCompleted: false,
      };
    case HomeActionTypes.ChangeActivityCompleted:
      return {
        ...state,
        changeActivityLoading: false,
        changeActivityCompleted: true,
      };
    case HomeActionTypes.StartLoadHomeInformation:
      return {
        ...state,
        homeInformationLoading: true,
        homeMetricLoadingComplete: false,
      };
    case HomeActionTypes.GetQuantityFromSensor:
      return {
        ...state,
      };
    case HomeActionTypes.ActivityTreeGraphDataLoaded:
      return {
        ...state,
        activityTreeGraphDataLoading: false,
        activityTreeGraphDataLoaded: true,
        activityTreeGraphData: action.payload['data'],
      };
    case HomeActionTypes.SaveWorkOrderFeedback:
      return {
        ...state,
        saveWorkOrderFeedbackLoading: true,
        saveWorkOrderFeedbackLoaded: false,
      };
    case HomeActionTypes.SaveWorkOrderFeedbackLoaded:
      return {
        ...state,
        saveWorkOrderFeedbackLoading: false,
        saveWorkOrderFeedbackLoaded: true,
      };
    case HomeActionTypes.ClearWorkOrderFeedbackForm:
      return {
        ...state,
        saveWorkOrderFeedbackLoading: false,
        saveWorkOrderFeedbackLoaded: false,
      };
    case HomeActionTypes.GetWorkOrderFeedbackLoading:
      return {
        ...state,
        getWorkOrderFeedbackLoading: true,
        getWorkOrderFeedbackLoaded: false,
      };
    case HomeActionTypes.GetWorkOrderFeedbackLoaded:
      const workOrderCloseFeedback = {
        id: null,
        workOrderId: null,
        crewPerformPoint: null,
        goodThings: '',
        needToBeImprove: '',
      };

      if (action.workOrderCloseFeedbackData) {
        workOrderCloseFeedback.id = action.workOrderCloseFeedbackData.id;
        workOrderCloseFeedback.workOrderId = action.workOrderCloseFeedbackData.workOrderId;
        workOrderCloseFeedback.crewPerformPoint = action.workOrderCloseFeedbackData.crewPerformPoint;
        workOrderCloseFeedback.goodThings = action.workOrderCloseFeedbackData.goodThings;
        workOrderCloseFeedback.needToBeImprove = action.workOrderCloseFeedbackData.needToBeImprove;
      }

      return {
        ...state,
        ...{
          workOrderCloseFeedback,
        },
        getWorkOrderFeedbackLoading: false,
        getWorkOrderFeedbackLoaded: true,
      };
    case HomeActionTypes.UpdateWorkOrderFeedbackLoading:
      return {
        ...state,
        updateWorkOrderFeedbackLoading: true,
        updateWorkOrderFeedbackLoaded: false,
      };
    case HomeActionTypes.UpdateWorkOrderFeedbackCompleted:
      return {
        ...state,
        updateWorkOrderFeedbackLoading: false,
        updateWorkOrderFeedbackLoaded: true,
      };
    case HomeActionTypes.SetHomeActivityButtons:
      return {
        ...state,
        generatedActivityButtons: action.payload,
      };
    case HomeActionTypes.HomeInformationLoaded:
      return {
        ...state,
        homeInformationLoading: false,
        homeInformationLoaded: true,
        ...action.payload.data,
      };
    case HomeActionTypes.UpdateCurrentActivity:
      return {
        ...state,
        requestType: action.requestType,
        updateCurrentActivityLoading: true,
      };
    case HomeActionTypes.UpdateCurrentActivityCompleted:
      const line = HelperService.cloneDeep(state.line);
      const data: UpdateCurrentActivityResponseModel = HelperService.cloneDeep(action.payload.data);

      if (data.selectedPhaseId !== undefined) {
        line.activityCard.selectedPhase = data.selectedPhaseId;
      }

      if (data.currentTask !== null) {
        line.activityCard.ignorePhase = data.currentTask.ignorePhase === 1;
      }

      line.activityCard.auditLogUuid = data.auditLogUuid;
      line.auditLogUuid = data.auditLogUuid;

      return {
        ...state,
        ...{
          line,
        },
        updateCurrentActivityLoading: false,
      };
    case HomeActionTypes.CheckWorkOrder:
      return {
        ...state,
        checkWorkOrderLoading: true,
      };
    case HomeActionTypes.CheckWorkOrderCompleted:
      return {
        ...state,
        checkWorkOrderLoading: false,
      };
    case HomeActionTypes.UpdateWorkOrder:
      return {
        ...state,
        updateWorkOrderLoading: true,
      };
    case HomeActionTypes.UpdateWorkOrderCompleted:
      return {
        ...state,
        updateWorkOrderLoading: false,
      };
    case HomeActionTypes.GetWorkOrder:
      return {
        ...state,
        getWorkOrderLoading: true,
      };
    case HomeActionTypes.GetWorkOrderCompleted:
      return {
        ...state,
        getWorkOrderLoading: false,
      };
    case HomeActionTypes.WorkOrderStatus:
      return {
        ...state,
        workOrderStatusLoading: true,
      };
    case HomeActionTypes.WorkOrderStatusCompleted:
      return {
        ...state,
        workOrderStatusLoading: false,
      };
    case HomeActionTypes.GetVersionDetail:
      return {
        ...state,
        getVersionDetailLoading: true,
      };
    case HomeActionTypes.GetVersionDetailCompleted:
      return {
        ...state,
        getVersionDetailLoading: false,
      };
    case HomeActionTypes.GetProductPerformance:
      return {
        ...state,
        getProductPerformanceLoading: true,
      };
    case HomeActionTypes.GetProductPerformanceCompleted:
      return {
        ...state,
        getProductPerformanceLoading: false,
      };
    case HomeActionTypes.ProductSearch:
      return {
        ...state,
        productSearchLoading: true,
      };
    case HomeActionTypes.ProductSearchCompleted:
      return {
        ...state,
        productSearchLoading: false,
      };
    case HomeActionTypes.GetWorkOrderNumbers:
      return {
        ...state,
        getWorkOrderNumbersLoading: true,
      };
    case HomeActionTypes.GetWorkOrderNumbersCompleted:
      return {
        ...state,
        getWorkOrderNumbersLoading: false,
      };
    case HomeActionTypes.SearchUsersByFilter:
      return {
        ...state,
        searchUsersByFilterLoading: true,
      };
    case HomeActionTypes.SearchUsersByFilterCompleted:
      return {
        ...state,
        searchUsersByFilterLoading: false,
      };
    case HomeActionTypes.SearchAssetsByFilter:
      return {
        ...state,
        searchAssetsByFilterLoading: true,
      };
    case HomeActionTypes.SearchAssetsByFilterCompleted:
      return {
        ...state,
        searchAssetsByFilterLoading: false,
      };
    case HomeActionTypes.FetchError:
      const loadedActions = {
        [HomeActionTypes.UpdateCurrentActivityCompleted]: { updateCurrentActivityLoading: false },
      };

      const actionType = action.actionType || 'noAction';

      return _.assign(
        {
          ...state,
          errors: action.payload,
        },
        loadedActions[actionType] || {},
      );
    case HomeActionTypes.HomeMetricSetItemsSetDefaultState:
      return {
        ...state,
        homeMetricSetItemsLoading: false,
        homeMetricSetItemsLoaded: false,
      };
    case HomeActionTypes.HomeMetricSetItemsLoading:
      return {
        ...state,
        homeMetricSetItemsParams: action,
        homeMetricSetItemsLoading: true,
        homeMetricSetItemsLoaded: false,
      };
    case HomeActionTypes.HomeMetricSetItemsLoaded:
      let homeMetricSetItems: IHomeMetricSetItem[] = [];

      if (action.payload.length) {
        const layoutData: ILayout = action.payload[0]?.homeMetricSet?.[0]
          ? action.payload[0]
          : action.payload.find((item: ILayout) => item.name === 'scwDefaultLayout');
        const page: string = state.homeMetricSetItemsParams?.page || EPages.HOME;

        homeMetricSetItems =
          layoutData?.homeMetricSet?.find((item: IHomeMetricSet) => item.page === page).homeMetricSetItems || [];
      }

      const layoutTaskGroupItem: ILayoutTaskGroupItem[] =
        action.payload[0]?.layoutTaskGroupItem?.filter((item: ILayoutTaskGroupItem) => {
          const isLineMatch: boolean = item.lineId === state.homeMetricSetItemsParams.lineId;
          const isNotHidden: boolean = !Boolean(item?.task?.hideOnHomePage);
          const lineActivityIds: number[] = item.line?.activityIds?.split(',').map((id: string) => Number(id)) || [];
          const isActivityValid: boolean = lineActivityIds.includes(item.task?.activityId);
          const isActive: boolean = item?.task?.statusId === StatusesEnum.ACTIVE;

          return isActive && isLineMatch && isNotHidden && isActivityValid;
        }) ?? [];

      return {
        ...state,
        ...{
          homeMetricSetItems,
          isDefaultFavTask: action.payload[0]?.isDefaultFavTask && layoutTaskGroupItem.length > 0,
          layoutTaskGroupItem,
        },
        homeMetricSetItemsLoading: false,
        homeMetricSetItemsLoaded: true,
        homeMetricLoadingComplete: true,
      };
    case HomeActionTypes.PhaseDurationsLoading:
      return {
        ...state,
        phaseDurationLoading: true,
        phaseDurationLoaded: false,
      };
    case HomeActionTypes.PhaseDurationsLoaded:
      return {
        ...state,
        ...{
          phaseDurations: action.payload,
        },
        phaseDurationLoading: false,
        phaseDurationLoaded: true,
      };
    case HomeActionTypes.PhaseDurationIntervalTick:
      const phaseDurations = HelperService.cloneDeep(state.phaseDurations);

      if (phaseDurations?.[action.phaseTickType]) {
        phaseDurations[action.phaseTickType] = +phaseDurations[action.phaseTickType] + 60;
        phaseDurations[PhaseDurationTypeEnum.totalDuration] = +phaseDurations[PhaseDurationTypeEnum.totalDuration] + 60;
      }

      return {
        ...state,
        ...{
          phaseDurations,
        },
      };
    case HomeActionTypes.ResetPhaseDurationOnSiteLineSelection:
      return {
        ...state,
        ...{
          phaseDurationLoading: false,
          phaseDurationLoaded: false,
          phaseDurations: null,
        },
      };
    case HomeActionTypes.PhaseCommentsLoading:
      return {
        ...state,
        phaseCommentsLoading: true,
        phaseCommentsLoaded: false,
      };
    case HomeActionTypes.UpdatePhaseComment:
    case HomeActionTypes.DeletePhaseComment:
    case HomeActionTypes.CreatePhaseComment:
      return {
        ...state,
        phaseCommentSubmitLoading: true,
        phaseCommentSubmitLoaded: false,
      };
    case HomeActionTypes.PhaseCommentsLoaded:
      return {
        ...state,
        phaseComments: {
          ...action.response,
        },
        phaseCommentsLoading: false,
        phaseCommentsLoaded: true,
      };
    case HomeActionTypes.UpdatePhaseCommentCompleted:
    case HomeActionTypes.CreatePhaseCommentCompleted:
      return {
        ...state,
        phaseComments: {
          ...state.phaseComments,
          ...action.response,
        },
        phaseCommentSubmitLoading: false,
        phaseCommentSubmitLoaded: true,
      };
    case HomeActionTypes.DeletePhaseCommentCompleted:
      const newPhaseComments = { ...state.phaseComments };
      for (const key of Object.keys(newPhaseComments)) {
        if (newPhaseComments[key] !== null && newPhaseComments[key].id === action.deletedId) {
          newPhaseComments[key] = null;
          break;
        }
      }

      return {
        ...state,
        phaseComments: newPhaseComments,
        phaseCommentSubmitLoading: false,
        phaseCommentSubmitLoaded: true,
      };
    case HomeActionTypes.UpdateIsAutomatedPhaseCommentsActive:
      return {
        ...state,
        isAutomatedPhaseCommentsActive: action.isAutomatedPhaseCommentsActive,
      };
    case HomeActionTypes.UpdatePhaseCommentsEnteredStatus:
      return {
        ...state,
        phaseCommentsEnteredStatus: action.phaseCommentsEnteredStatus,
      };
    case HomeActionTypes.UpdatePreviousPhase:
      return {
        ...state,
        previousPhase: action.previousPhase,
      };
    case HomeActionTypes.GetLineInfoThatSelectedWorkOrder:
      return {
        ...state,
        getLineInfoThatSelectedWorkOrderLoading: true,
        getLineInfoThatSelectedWorkOrderLoaded: false,
      };
    case HomeActionTypes.GetLineInfoThatSelectedWorkOrderCompleted:
      return {
        ...state,
        getLineInfoThatSelectedWorkOrderData: action.payload,
        getLineInfoThatSelectedWorkOrderLoading: false,
        getLineInfoThatSelectedWorkOrderLoaded: true,
      };
    case HomeActionTypes.SetRequestType:
      return {
        ...state,
        requestType: action.requestType,
      };
    case HomeActionTypes.SplitWorkOrderOnLinePredictedWorkOrderNumberLoad:
      return {
        ...state,
        splitWorkOrderOnLinePredictedWorkOrderNumberLoading: true,
        splitWorkOrderOnLinePredictedWorkOrderNumberLoaded: false,
      };
    case HomeActionTypes.SplitWorkOrderOnLinePredictedWorkOrderNumberLoaded:
      return {
        ...state,
        splitWorkOrderOnLinePredictedWorkOrderNumberData: action.payload,
        splitWorkOrderOnLinePredictedWorkOrderNumberLoading: false,
        splitWorkOrderOnLinePredictedWorkOrderNumberLoaded: true,
      };
    case HomeActionTypes.StartActivityHistoryDataLoading:
      return {
        ...state,
        activityHistoryDataLoading: true,
        activityHistoryDataLoaded: false,
      };
    case HomeActionTypes.ActivityHistoryDataLoaded:
      return {
        ...state,
        activityHistoryDataLoaded: true,
        activityHistoryDataLoading: false,
        activityHistoryData: { ...action.payload },
      };
    case HomeActionTypes.GetProductTransitionMatrix:
      return {
        ...state,
        getProductTransitionMatrixLoading: true,
        getProductTransitionMatrixLoaded: false,
      };
    case HomeActionTypes.GetProductTransitionMatrixCompleted:
      return {
        ...state,
        getProductTransitionMatrixLoading: false,
        getProductTransitionMatrixLoaded: true,
        productTransitionMatrix: action.payload,
      };
    case HomeActionTypes.GetPreviousWorkOrder:
      return {
        ...state,
        getPreviousWorkOrderLoading: true,
        getPreviousWorkOrderLoaded: false,
      };
    case HomeActionTypes.GetPreviousWorkOrderCompleted:
      return {
        ...state,
        getPreviousWorkOrderLoading: false,
        getPreviousWorkOrderLoaded: true,
        previousWorkOrder: action.payload,
      };
    case HomeActionTypes.GetIsLinePathUtilizedCompleted:
      return {
        ...state,
        isLinePathUtilized: action.payload,
      };
    case HomeActionTypes.WorkOrderMissingControl:
      return {
        ...state,
        isWorkOrderMissing: false,
        workOrderMissingControlLoading: true,
        workOrderMissingControlLoaded: false,
      };
    case HomeActionTypes.WorkOrderMissingControlCompleted:
      return {
        ...state,
        isWorkOrderMissing: action.payload.isMissing,
        workOrderMissingControlLoading: false,
        workOrderMissingControlLoaded: true,
      };
    case HomeActionTypes.SetZeroCountInformation:
      return {
        ...state,
        microStopSensorType: action.payload.microStopSensorType,
        isZeroCuntReceived: action.payload.isZeroCuntReceived,
      };
    case HomeActionTypes.GetSelectedLineWorkOrderSplitStatus:
      return {
        ...state,
        getSelectedLineWorkOrderSplitStatusLoading: true,
        getSelectedLineWorkOrderSplitStatusLoaded: false,
      };
    case HomeActionTypes.GetSelectedLineWorkOrderSplitStatusCompleted:
      return {
        ...state,
        getSelectedLineWorkOrderSplitStatusLoading: false,
        getSelectedLineWorkOrderSplitStatusLoaded: true,
        selectedLineIsWorkOrderSplitActive: action.isWorkOrderSplitActive,
      };
    case HomeActionTypes.GetExpectedTargetSpeed:
      return {
        ...state,
        getTargetSpeedPlaceholderLoading: true,
        getTargetSpeedPlaceholderLoaded: false,
      };
    case HomeActionTypes.GetExpectedTargetSpeedCompleted:
      return {
        ...state,
        getTargetSpeedPlaceholderLoading: false,
        getTargetSpeedPlaceholderLoaded: true,
        expectedTargetSpeed: action.expectedTargetSpeed,
      };
      case HomeActionTypes.RemoveWorkOrderFromLine:
      return {
        ...state,
        removeWorkOrderOnLineLoading: true,
        removeWorkOrderOnLineLoaded: false,
      };
    case HomeActionTypes.RemoveWorkOrderOnLineCompleted:
      return {
        ...state,
        removeWorkOrderOnLineLoading: false,
        removeWorkOrderOnLineLoaded: true,
      };
    default:
      return state;
  }
}
